import React from "react";
import MainProviderInfo from "./MainProviderInfo";

interface MainProviderProps {
  identificationTypes: any;
  nationality: any;
  maritalStatus: any;
  maleOrphans: any;
  femaleOrphans: any;
  orphansBeneficiaryInfo: any;
  guardianRelationships: any;
  banks: any;
  form: any;
  formBank: any;
}

const MainProvider = ({
  identificationTypes,
  nationality,
  maritalStatus,
  femaleOrphans,
  maleOrphans,
  orphansBeneficiaryInfo,
  guardianRelationships,
  banks,
  form,
  formBank,
}: MainProviderProps) => {
  return (
    <div style={{ padding: "2rem" }}>
      <MainProviderInfo
        formBank={formBank}
        form={form}
        identificationTypes={identificationTypes}
        nationality={nationality}
        maritalStatus={maritalStatus}
        femaleOrphans={femaleOrphans}
        maleOrphans={maleOrphans}
        orphansBeneficiaryInfo={orphansBeneficiaryInfo}
        guardianRelationships={guardianRelationships}
        banks={banks}
      />
    </div>
  );
};

export default MainProvider;
